/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";

// SidebarLinks Component
export function SidebarLinks(props) {
  const location = useLocation();
  const { routes } = props;

  // Checks if current route is active
const activeRoute = (route) => {
  const currentPath = location.pathname;
  const fullPath = route.layout + "/" + route.path;

  // Match direct path with dynamic segment support
  const routePattern = fullPath.replace(/:[^/]+/g, "[^/]+");
  const routeRegex = new RegExp(`^${routePattern}$`);
  if (routeRegex.test(currentPath)) return true;

  // Match aliases (if present), with dynamic segment support
  if (route.aliases && Array.isArray(route.aliases)) {
    return route.aliases.some((alias) => {
      const aliasPattern = alias.replace(/:[^/]+/g, "[^/]+");
      const aliasRegex = new RegExp(`^${aliasPattern}$`);
      return aliasRegex.test(currentPath);
    });
  }

  return false;
};


  const createLinks = (routes) => {
    return routes
      .filter(
        (route) =>
          (route.layout === "/admin" ||
            route.layout === "/auth" ||
            route.layout === "/rtl") &&
          route.showInSidebar !== false // ✅ filter out hidden ones
      )
      .map((route, index) => (
  <Link key={index} to={route.layout + "/" + route.path}>
    <div className="relative mb-3 flex hover:cursor-pointer">
      <li className="my-[3px] flex cursor-pointer items-center px-8">
        <span
          className={`${
            activeRoute(route) // ✅ FIXED here
              ? "font-bold text-brand-500 dark:text-white"
              : "font-medium text-gray-600"
          }`}
        >
          {route.icon ? route.icon : <DashIcon />}{" "}
        </span>
        <p
          className={`leading-1 ml-4 flex ${
            activeRoute(route) // ✅ FIXED here
              ? "font-bold text-navy-700 dark:text-white"
              : "font-medium text-gray-600"
          }`}
        >
          {route.name}
        </p>
      </li>
      {activeRoute(route) ? ( // ✅ FIXED here
        <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
      ) : null}
    </div>
  </Link>
))

  };

  return createLinks(routes);
}

export default SidebarLinks;
